import React, { useEffect, useMemo } from "react";
import CustomButton, { OutlineCustomButton } from "shared/components/inputButton";
import { formatDateToMMDDYYYY } from "utils/common";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const SideArtistDocument = ({
  contractDetails,
  sign,
  setSign,
  handleClear,
  onSignSubmit,
  htmlContent,
  setHtmlContent,
  modules,
  formats,
}) => {
  // Format dates
  const formattedDates = useMemo(() => ({
    agreementDate: formatDateToMMDDYYYY(contractDetails?.payload?.agreementDate),
    deadline: formatDateToMMDDYYYY(contractDetails?.payload?.details?.deadline)
  }), [contractDetails]);

  // ... (keep all the existing memoized content generation code)

  // Check if we're in the signing phase (only AWAITING_SIGNING now)
  const isSigningPhase = contractDetails?.payload?.status === "AWAITING_SIGNING";

  // Signature display logic
  const renderSignature = (role, title) => {
    const existingSignature = contractDetails?.payload?.signatures?.find(
      (sig) => sig.role === role
    );
    const currentSignature = sign[role];

    return (
      <>
        <p className="mt-6 mb-3">{title}</p>
        <h3 className="mt-6 mb-3">
          <div style={{ position: "relative" }}>
            {/* Display signature - prioritize existing saved signatures */}
            {existingSignature ? (
              existingSignature.signature ? (
                <img
                  src={existingSignature.signature}
                  style={{ width: "150px", height: "auto" }}
                  alt={`${title} Signature`}
                />
              ) : (
                <div
                  style={{
                    minWidth: "150px",
                    borderBottom: "1px solid #000",
                    paddingBottom: "4px",
                    fontFamily: "cursive",
                  }}
                >
                  {existingSignature.typedSignature || " "}
                </div>
              )
            ) : currentSignature?.signature ? (
              <img
                src={currentSignature.signature}
                style={{ width: "150px", height: "auto" }}
                alt={`${title} Signature`}
              />
            ) : (
              <div
                style={{
                  minWidth: "150px",
                  borderBottom: "1px solid #000",
                  paddingBottom: "4px",
                  fontFamily: "cursive",
                }}
              >
                {currentSignature?.typedSignature || " "}
              </div>
            )}

            {/* Sign buttons - only show if in AWAITING_SIGNING phase and no existing signature */}
            {isSigningPhase && !existingSignature && (
              <div style={{ marginTop: "8px", display: "flex", gap: "8px" }}>
                {!currentSignature?.signature && !currentSignature?.typedSignature ? (
                  <CustomButton
                    label="Sign"
                    onClick={() => onSignSubmit(role)}
                    disabled={false}
                  />
                ) : (
                  <>
                    <CustomButton
                      label="Resign"
                      onClick={() => onSignSubmit(role)}
                      disabled={false}
                    />
                    <OutlineCustomButton
                      label="Clear"
                      onClick={() => {
                        if (typeof handleClear === "function") {
                          handleClear(role);
                        } else {
                          setSign((prev) => ({
                            ...prev,
                            [role]: { signature: "", typedSignature: "" },
                          }));
                        }
                      }}
                    />
                  </>
                )}
              </div>
            )}
          </div>
        </h3>
      </>
    );
  };

  return (
    <div>
      <div className="bg-white shadow-1 p-5">
        <ReactQuill
          value={htmlContent}
          onChange={setHtmlContent}
          modules={modules}
          formats={formats}
          theme="snow"
          readOnly={false}
        />
        {/* Show signatures in all states but buttons only in AWAITING_SIGNING */}
        {(contractDetails?.payload?.status === "AWAITING_SIGNING" ||
         contractDetails?.payload?.status === "AWAITING_SHARE" ||
         contractDetails?.payload?.status === "SHARED_WITH_PARTY") && (
          <>
            {renderSignature("artist", "Artist")}
            {renderSignature("sideArtist", "Side Artist")}
            
            {/* Conditionally render label signatures if waiver exists */}
            {contractDetails?.payload?.details?.labelWavier === "Yes" && (
              <>
                {renderSignature("label", "Label Representative")}
                {renderSignature("sideArtistLabel", "Side Artist Label")}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default SideArtistDocument;
